import React from "react";
import styles from "Styles/main.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({
      hasError: true,
      error: error,
      info: info
    });
    // You can also log the error to an error reporting service
    if (PRODUCTION) {
      console.error(error);
      console.info(info);
    }
  }

  render() {
    const { hasError, info, error } = this.state;
    if (hasError) {
      // You can render any custom fallback UI
      return PRODUCTION ? (
        <div>
          Sorry, something went wrong !
        </div>
      ) : (
        <div className={styles.grid}>
          <div className={styles.container}>
            <h2>Oops, something went wrong :(</h2>
            <p>The error: {this.state.error.toString()}</p>
            <p>Where it occurred: {this.state.info.componentStack}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  //prop: PropTypes.string.isRequired
};
export default ErrorBoundary;
